(function () {
  function initMembershipPopup() {
    var popup = document.querySelector('[data-membership-popup]');
    if (!popup || popup.dataset.membershipPopupInitialized) return;
    popup.dataset.membershipPopupInitialized = 'true';

    // Move to a direct child of <body> so position:fixed centering can
    // never be broken by an ancestor's overflow/stacking context - same
    // defensive pattern already used for the shipping-info popover (see
    // initShippingInfoTriggers in product-redesign.js).
    document.body.appendChild(popup);

    var overlay = popup.querySelector('[data-membership-popup-overlay]');
    var closeBtn = popup.querySelector('[data-membership-popup-close]');
    var trigger = document.querySelector('[data-membership-popup-trigger]');

    function openPopup(event) {
      if (event) event.preventDefault();
      popup.hidden = false;
      document.body.classList.add('membership-popup-open');
    }

    function closePopup() {
      popup.hidden = true;
      document.body.classList.remove('membership-popup-open');
    }

    if (trigger) {
      trigger.addEventListener('click', openPopup);
    }
    if (overlay) {
      overlay.addEventListener('click', closePopup);
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', closePopup);
    }
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !popup.hidden) closePopup();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMembershipPopup);
  } else {
    initMembershipPopup();
  }

  document.addEventListener('shopify:section:load', initMembershipPopup);
})();
